import { format, parseJSON, parse } from "date-fns";

const formatDate = (date, pattern) => {
  if(date) return format(parseJSON(date), pattern || 'MMM dd, yyyy  hh:mm a')
}

const parseDate = (date)  => {
  return  date ? parseJSON(date) : date;
}

/**
 * Parse and format date without timezone.
 * @param {Date} date
 * @param {String} inputFormat - Input date string format.
 *  default value: 'yyyy-MM-dd'
 * @param {String} outputFormat - Output date format.
 *  default value: 'MMM dd, yyyy'
 * @returns {String, undefined}
 */
const formatDateWithoutTimezone = (date, inputFormat, outputFormat) => {
  if(date){
    return format(
      parseDateWithoutTimezone(date, inputFormat),
      outputFormat || 'MMM dd, yyyy'
    );
  }
}

/**
 * Parse date without timezone.
 * @param {Date} date
 * @param {String} format - Input date string format.
 *  default value: 'yyyy-MM-dd'
 * @returns {Date}
 */
 const parseDateWithoutTimezone = (date, format) => {
  if(date){
    return parse(date, format || 'yyyy-MM-dd', new Date());
  }
}

export {
  formatDate,
  parseDate,
  formatDateWithoutTimezone,
  parseDateWithoutTimezone,
}